export function generatedID(label: string, id: string | null) {
	if (id) return id;

	return label.toLowerCase().replace(/ /g, "-");
}
